/**
 * Hue Custom Quiz Result Drawer
 * Renders the TryNow custom result layout when quiz is completed via .trynow-shade-atc.
 * Keeps section renderers separate so the file stays maintainable.
 *
 * Data schema: see docs/hue-quiz-result-drawer.md (QuizResult, StorefrontVariantData, Review, etc.)
 */

(function () {
  'use strict';

  var TRYNOW_SELLING_PLAN_ID = 2112815165;

    // Track if quiz was opened via nav bar "Find My Shade" link
  document.addEventListener('click', function(e) {
    if (!window.HUE_DRAWER_CONFIG) window.HUE_DRAWER_CONFIG = {};
    var navLink = e.target.closest('a');
    if (navLink && navLink.closest('header, nav, .header') && navLink.textContent.trim().toUpperCase().indexOf('FIND MY SHADE') !== -1) {
      window.HUE_DRAWER_CONFIG.fromNavQuiz = true;
    } else if (e.target.closest('[data-hue-trigger="quiz"]')) {
      window.HUE_DRAWER_CONFIG.fromNavQuiz = false;
    }
  }, true);

  // ─── Section: Header ("Try Your Perfect Shade Free" banner) ─────────────────
  function injectDrawerHeaderStyles() {
    if (document.getElementById('hue-drawer-header-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-header-styles';
    style.textContent = `
      #hue-custom-quiz-results {
        margin-top: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .hue-drawer-header {
        background: linear-gradient(90deg, #EAE8E9 0%, #B0B0B0 100%);
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        display: flex;
        align-items: stretch;
        min-height: 120px;
      }
      .hue-drawer-header__inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 0 0 24px;
        flex: 1;
        min-width: 0;
      }
      .hue-drawer-header__lines {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        width: 100%;
        margin-bottom: 8px;
      }
      .hue-drawer-header__line1 {
        font-family: Georgia, "Times New Roman", serif;
        font-weight: bold;
        font-size: 20px;
        line-height: 1.2;
        color: #1a1a1a;
        margin: 0;
        flex-shrink: 0;
      }
      .hue-drawer-header__line2 {
        font-family: Georgia, "Times New Roman", serif;
        font-weight: bold;
        font-size: 28px;
        line-height: 1.2;
        color: #1a1a1a;
        margin: 0;
        flex: 1;
        min-width: 0;
      }
      .hue-drawer-header__line2 .hue-drawer-header__free {
        color: #e91e8c;
      }
      .hue-drawer-header__cta {
        font-size: 15px;
        color: #333;
        margin: 0;
        font-family: 'brandon-grotesque', sans-serif;
        font-weight: 700;
      }
      .hue-drawer-header__free{
      font-family: Georgia, "Times New Roman", serif;  font-weight: bold;
        color: #e91e8c;
      }
      .hue-drawer-header__media {
        flex-shrink: 0;
        width: 32%;
        max-width: 240px;
        position: relative;
        overflow: hidden;
      }
      .hue-drawer-header__media img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 140%;
        width: auto;
        max-width: none;
        object-fit: scale-down;
        object-position: right center;
      }
      .hue-drawer-header--blush .hue-drawer-header__media img {
        right: -80px;
        top: 50%;
        height: 185%;
      }
      @media (max-width: 768px) {
        .hue-drawer-header__line1 {
          width: 85%;
        }
        .hue-drawer-header__media {
          width: 40%;
        }
      }
      .hue-drawer-header--no-image {
        min-height: 70px;
      }
      .hue-drawer-header--no-image .hue-drawer-header__media {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }

  function toAbsoluteAssetUrl(url) {
    if (!url || typeof url !== 'string') return '';
    var u = url.trim();
    if (u.indexOf('http://') === 0 || u.indexOf('https://') === 0) return u;
    if (u.indexOf('//') === 0) return (typeof window !== 'undefined' && window.location && window.location.protocol) ? window.location.protocol + u : 'https:' + u;
    var origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
    return origin + (u.indexOf('/') === 0 ? u : '/' + u);
  }

  function renderHeader(parent, data) {
    injectDrawerHeaderStyles();
    var useBlush = !!(window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.useBlushHeaderImage);
    if (useBlush && window.HUE_DRAWER_CONFIG) window.HUE_DRAWER_CONFIG.useBlushHeaderImage = false;
    var handle = (data && data.storefrontProductVariant && data.storefrontProductVariant.storefrontProduct && data.storefrontProductVariant.storefrontProduct.handle) || (data && data.storefrontProduct && data.storefrontProduct.handle) || (data && data.product_handle) || (data && data.matched_products && data.matched_products[0] && data.matched_products[0].handle) || '';
    var isBlush = useBlush || /blush/i.test(handle);
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-header' + (isBlush ? ' hue-drawer-header--blush' : '');
    section.setAttribute('data-hue-drawer', 'header');
    var rawUrl = (window.HUE_DRAWER_CONFIG && (isBlush ? window.HUE_DRAWER_CONFIG.headerImageUrlBlush : window.HUE_DRAWER_CONFIG.headerImageUrl)) || '';
    var headerImageUrl = toAbsoluteAssetUrl(rawUrl);
    var fromNav = !!(window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.fromNavQuiz);
    if (fromNav) {
      section.classList.add('hue-drawer-header--no-image');
    }
    section.innerHTML =
      '<div class="hue-drawer-header__inner">' +
        '<div class="hue-drawer-header__lines">' +
          '<p class="hue-drawer-header__line1">Try Your Perfect Shade <span class="hue-drawer-header__free">Free</span></p>' +
        '</div>' +
        '<p class="hue-drawer-header__cta">Limited Time Offer!</p>' +
      '</div>' +
      (headerImageUrl
        ? '<div class="hue-drawer-header__media"><img src="' + escapeAttr(headerImageUrl) + '" alt="" loading="eager" /></div>'
        : '');
    parent.appendChild(section);
  }

  function injectDrawerMatchStyles() {
    if (document.getElementById('hue-drawer-match-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-match-styles';
    style.textContent = `
      .hue-drawer-section.hue-drawer-match { padding: 25px 20px; margin: 0; }
      .hue-drawer-match__wrap { 
        padding: 10px;
        background: #FAF3ED;
      }
      .hue-drawer-match__inner {
        display: flex; gap: 16px; align-items: flex-start;
        margin-bottom: 16px;
      }
      .hue-drawer-match__media {
        flex-shrink: 0; width: 100px; height: 100px;
        border-radius: 0; overflow: hidden; background: #f5f5f5;
      }
      .hue-drawer-match__media img {
        width: 100%; height: 100%; object-fit: cover;
      }
      .hue-drawer-match__details { flex: 1; min-width: 0; }
      .hue-drawer-match__shade-row {
        display: flex; align-items: center; gap: 8px; margin-bottom: 4px;
      }
      .hue-drawer-match__shade-swatch {
        width: 20px; height: 20px; border-radius: 50%;
        border: 1px solid #ddd; flex-shrink: 0;
      }
      .hue-drawer-match__shade-name {
        font-size: 14px; font-weight: 700; text-transform: uppercase; color: #1a1a1a;
      }
      .hue-drawer-match__name {
        font-size: 14px; line-height: 1.3; color: #1a1a1a; margin: 0 0 8px 0;
      }
      .hue-drawer-match__features {
        list-style: none; margin: 0 0 10px 0; padding: 0;
        font-size: 14px; color: #333; line-height: 1.5;
      }
      .hue-drawer-match__features li {
        display: flex; align-items: center; gap: 8px; margin-bottom: 4px;
      }
      .hue-drawer-match__features li::before {
        content: "✓"; color: #1a1a1a; font-weight: bold;
      }
      .hue-drawer-match__price-row {
        display: flex; align-items: center; flex-wrap: wrap;
        margin-bottom: 10px;
      }
      .hue-drawer-match__price-now {
        display: inline-block;
        background: #E3008C;
        color: #fff;
        font-size: 14px; font-weight: 700;
        padding: 3px 7px;
        border-radius: 6px;
        text-transform: uppercase;
        letter-spacing: 0.02em;
      }
      .hue-drawer-match__price-struck {
        font-size: 13px; 
        font-weight: 400;
        color: #1a1a1a;
        margin-left: 5px;
        margin-right: 4px;
      }
      .hue-drawer-match__price-note {
        font-size: 13px;
        font-weight: 400;
        color: #1a1a1a;
      }
      .hue-drawer-match__atc {
        width: 100%; padding: 14px 20px; font-size: 14px; font-weight: 700;
        text-transform: uppercase; letter-spacing: 0.05em;
        background: #1a1a1a; color: #fff; border: none; cursor: pointer; margin: 0;
      }
      .hue-drawer-match__atc:hover { background: #333; }
      .hue-drawer-match__infobox {
        display: flex; align-items: center; gap: 24px;
        background: #FCFBFA; border: 1px solid #e2e2e2; padding: 10px 15px;
        width: 100%; margin: 0; box-sizing: border-box;
      }
      .hue-drawer-match__infobox-badge {
        flex-shrink: 0; width: 70px; height: 70px; border-radius: 50%;
        background-color: #fce4ec; display: flex; align-items: center; justify-content: center;
        border: 2.5px solid #f06292; transform: rotate(-5deg);
      }
      .hue-drawer-match__infobox-badge-text {
        font-size: 16px; font-weight: 800; color: #c62853;
        text-align: center; line-height: 1; letter-spacing: 0.5px;
      }
      .hue-drawer-match__infobox-content {
        display: flex; flex-direction: column; text-align: left; min-width: 0;
      }
      .hue-drawer-match__infobox-heading {
        font-size: 15px; font-weight: 700; color: #1a1a1a;
        letter-spacing: 0.3px; margin: 0 0 2px 0;
      }
      .hue-drawer-match__infobox-subtext {
        font-size: 13.5px; color: #333333;
        line-height: 1; margin: 0 0 6px 0;
      }
      .hue-drawer-match__infobox-hiw-wrap {
        display: inline-flex; align-items: center; gap: 6px; font-size: 13px; color: #444;
      }
      .hue-drawer-match__infobox-hiw {
        cursor: pointer; text-decoration: none; color: inherit;
        display: inline-flex; align-items: center; gap: 6px;
        background: none; border: none; padding: 0;
      }
      .hue-drawer-match__infobox-hiw-text {
        text-decoration: underline;
      }
      .hue-drawer-match__infobox-info-icon {
        width: 16px; height: 16px; border-radius: 50%;
        border: 1.5px solid #888; display: inline-flex; align-items: center; justify-content: center;
        font-size: 10px; font-weight: 600; color: #888;
        font-style: italic; font-family: Georgia, "Times New Roman", serif;
      }
      @media (max-width: 480px) {
        .hue-drawer-match__price-now { font-size: 12px; padding: 3px 7px; }
        .hue-drawer-match__price-struck { font-size: 13px; font-weight: 400; }
        .hue-drawer-match__infobox { gap: 10px; padding: 10px 15px; }
        .hue-drawer-match__infobox-badge { width: 60px; height: 60px; }
        .hue-drawer-match__infobox-badge-text { font-size: 14px; }
        .hue-drawer-match__infobox-subtext { font-size: 12.9px; }
        .hue-drawer-match__infobox-heading { font-size: 12px; white-space: nowrap; }
      }
    `;
    document.head.appendChild(style);
  }

  function injectDrawerModalZIndexStyles() {
    if (document.getElementById('hue-drawer-modal-zindex-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-modal-zindex-styles';
    style.textContent = `
      .ReactModal__Overlay.ReactModal__Overlay--after-open,
      .hue-dialog-sidebar {
        z-index: 999 !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ─── Section: Main match (product image, price, TryNow ATC, infobox) ────────
  function renderMatch(parent, data) {
    injectDrawerMatchStyles();
    const section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-match';
    section.setAttribute('data-hue-drawer', 'match');
    const v = data?.storefrontProductVariant;
    const variantId = v?.ext_id;
    const imageUrl = v?.imageUrl || v?.variant?.photoUrl;
    var currency = v?.storefrontProduct?.storefront?.currency?.symbol || '$';
    var priceStr = '';
    var apiPrice = v?.storefrontProduct?.price ?? v?.storefrontProduct?.product?.price;
    if (apiPrice != null && apiPrice !== '' && Number(apiPrice) !== 0) {
      priceStr = String(apiPrice);
    }
    const productName = v?.storefrontProduct?.product?.name || '';
    const shadeName = v?.variant?.name || '';
    const shadeHex = v?.variant?.colorHex || '';
    const checkmarks = v?.storefrontProduct?.config?.checkmarks || [];
    const trialDays = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.trialDays) || 14;

    var shadeSwatch = shadeHex
      ? '<span class="hue-drawer-match__shade-swatch" style="background-color:' + escapeAttr(shadeHex) + '"></span>'
      : '';
    var featureItems = (checkmarks || []).map(function (c) {
      return '<li>' + escapeHtml(c?.name || '') + '</li>';
    });
    featureItems.push('<li>14-Day Free Trial</li>');
    var featuresHtml = '<ul class="hue-drawer-match__features">' + featureItems.join('') + '</ul>';

    var priceRowHtml =
      '<div class="hue-drawer-match__price-row">' +
        '<span class="hue-drawer-match__price-now">$0 NOW</span>' +
        '<span class="hue-drawer-match__price-struck" data-hue-price-placeholder>' + (priceStr ? escapeHtml(currency) + escapeHtml(priceStr) : '') + '</span>' +
        '<span class="hue-drawer-match__price-note">IF YOU KEEP IT</span>' +
      '</div>';

    section.innerHTML =
      '<div class="hue-drawer-match__wrap">' +
        '<div class="hue-drawer-match__inner">' +
          (imageUrl ? '<div class="hue-drawer-match__media"><img src="' + escapeAttr(imageUrl) + '" alt="" loading="lazy" /></div>' : '') +
          '<div class="hue-drawer-match__details">' +
            (shadeName || shadeSwatch ? '<div class="hue-drawer-match__shade-row">' + shadeSwatch + (shadeName ? '<span class="hue-drawer-match__shade-name">' + escapeHtml(shadeName) + '</span>' : '') + '</div>' : '') +
            (productName ? '<p class="hue-drawer-match__name">' + escapeHtml(productName) + '</p>' : '') +
            featuresHtml +
            priceRowHtml +
            '<button type="button" class="hue-drawer-match__atc" data-hue-drawer-atc data-variant-id="' + escapeAttr(variantId || '') + '">TRY NOW FOR $0</button>' +
          '</div>' +
        '</div>' +
        '<div class="hue-drawer-match__infobox">' +
          '<div class="hue-drawer-match__infobox-badge">' +
            '<span class="hue-drawer-match__infobox-badge-text">FREE<br>TRIAL</span>' +
          '</div>' +
          '<div class="hue-drawer-match__infobox-content">' +
'<div class="hue-drawer-match__infobox-heading">NOT SURE ABOUT YOUR SHADE?</div>' +
          '<div class="hue-drawer-match__infobox-subtext">Try for ' + String(trialDays) + ' days. Only pay for what you love.<br>Free returns. Zero risk. Pure confidence.</div>' +
            '<div class="hue-drawer-match__infobox-hiw-wrap">' +
              '<button type="button" class="hue-drawer-match__infobox-hiw" data-hue-drawer-hiw aria-label="How it works">' +
                '<span class="hue-drawer-match__infobox-info-icon">i</span> <span class="hue-drawer-match__infobox-hiw-text">How it works</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    parent.appendChild(section);
  }

  // ─── Section: Shade alternatives (Still Not Sure? Try multiple shades) ──────


  // ─── Shared styles (used by both dropdown and grid) ───
  function injectDrawerShadeAlternativesStyles() {
    if (document.getElementById('hue-drawer-shade-alternatives-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-shade-alternatives-styles';
    style.textContent = `
      .hue-drawer-shade-alternatives { padding: 24px 20px 28px; margin: 0; background: #FCFBFA; }
      .hue-drawer-shade-alternatives__header { text-align: center; margin-bottom: 20px; }
      .hue-drawer-shade-alternatives__title { font-family: 'minion-3-display', serif; font-size: 24px; font-weight: 700; color: #1a1a1a; margin: 0 0 8px 0; }
      .hue-drawer-shade-alternatives__subtitle { font-size: 14px; font-weight: 400; color: #666; margin: 0 0 16px 0; font-family: 'brandon-grotesque', sans-serif; }
      .hue-drawer-shade-alternatives__dropdown-wrap { margin-bottom: 20px; }
      .hue-drawer-shade-alternatives__label { display: block; font-size: 14px; font-weight: 600; color: #1a1a1a; margin-bottom: 8px; font-family: 'brandon-grotesque', sans-serif; }
      .hue-drawer-shade-alternatives__variant-select {
        width: 100%; max-width: 500px; position: relative; box-sizing: border-box;
      }
      .hue-drawer-shade-alternatives__control {
        display: flex; align-items: center; gap: 12px; width: 100%;
        padding: 12px 14px; min-height: 56px; box-sizing: border-box;
        border: none; background: #FAF3ED; cursor: pointer;
        font-family: 'brandon-grotesque', sans-serif; text-align: left;
      }
      .hue-drawer-shade-alternatives__value-wrap { flex: 1; min-width: 0; }
      .hue-drawer-shade-alternatives__swatch {
        flex-shrink: 0; width: 40px; height: 40px; border-radius: 0;
        overflow: hidden; background: #eee; border: 1px solid #ddd;
      }
      .hue-drawer-shade-alternatives__swatch img { width: 100%; height: 100%; object-fit: cover; }
      .hue-drawer-shade-alternatives__value { font-size: 1.6rem; font-weight: 700; color: #1a1a1a; margin: 0 0 2px 0; }
      .hue-drawer-shade-alternatives__value-description { font-size: 1.6rem; font-weight: 400; color: #666; margin: 0; }
      .hue-drawer-shade-alternatives__indicator {
        flex-shrink: 0; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;
      }
      .hue-drawer-shade-alternatives__indicator svg { width: 20px; height: 20px; }
      .hue-drawer-shade-alternatives__control.is-open .hue-drawer-shade-alternatives__indicator { transform: rotate(180deg); }
      .hue-drawer-shade-alternatives__menu {
        position: absolute; left: 0; right: 0; top: 100%; z-index: 10;
        max-height: 280px; overflow-y: auto; overflow-x: hidden;
        border: none; background: #fff; display: none;
      }
      .hue-drawer-shade-alternatives__menu.is-open { display: block; }
      .hue-drawer-shade-alternatives__option {
        display: flex; align-items: center; gap: 12px; padding: 12px 14px;
        cursor: pointer; border: none; width: 100%; box-sizing: border-box;
        font-family: 'brandon-grotesque', sans-serif; text-align: left; background: #fff;
      }
      .hue-drawer-shade-alternatives__option:hover { background: #f9f9f9; }
      .hue-drawer-shade-alternatives__option.is-selected { background: #f5f2ef; }
      .hue-drawer-shade-alternatives__option .hue-drawer-shade-alternatives__swatch { width: 40px; height: 40px; }
      .hue-drawer-shade-alternatives__option .hue-drawer-shade-alternatives__value-wrap { flex: 1; min-width: 0; }
      .hue-drawer-shade-alternatives__atc {
        width: 100%; padding: 14px 20px; font-size: 14px; font-weight: 700;
        text-transform: uppercase; background: #1a1a1a; color: #fff; border: none;
        cursor: pointer; margin: 0; font-family: 'brandon-grotesque', sans-serif;
      }
      .hue-drawer-shade-alternatives__atc:hover { background: #333; }
      .hue-drawer-shade-alternatives__atc:disabled { opacity: 0.6; cursor: not-allowed; }

      /* ─── Grid (checkbox) styles ─── */
      .hue-drawer-shade-grid {
        display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;
        margin-bottom: 20px;
      }
      .hue-drawer-shade-grid__card {
        position: relative; cursor: pointer; border: 1px solid #ddd;
        background: #f5f5f5; text-align: center; overflow: hidden;
        transition: border-color 0.15s;
      }
      .hue-drawer-shade-grid__card.is-checked {
        border: 2px solid #1a1a1a;
      }
      .hue-drawer-shade-grid__checkbox {
        position: absolute; top: 8px; left: 8px; width: 24px; height: 24px;
        border: 2px solid #1a1a1a; background: #fff; display: flex;
        align-items: center; justify-content: center; z-index: 2;
        pointer-events: none;
      }
      .hue-drawer-shade-grid__card.is-checked .hue-drawer-shade-grid__checkbox {
        background: #1a1a1a;
      }
      .hue-drawer-shade-grid__checkbox svg {
        width: 14px; height: 14px; display: none;
      }
      .hue-drawer-shade-grid__card.is-checked .hue-drawer-shade-grid__checkbox svg {
        display: block;
      }
      .hue-drawer-shade-grid__image {
        width: 100%; aspect-ratio: 1 / 1; object-fit: cover; display: block;
      }
      .hue-drawer-shade-grid__label {
        display: flex; align-items: center; justify-content: center; gap: 6px;
        padding: 8px 4px; font-size: 12px; font-weight: 700;
        text-transform: uppercase; color: #1a1a1a;
        font-family: 'brandon-grotesque', sans-serif;
      }
      .hue-drawer-shade-grid__color-dot {
        width: 12px; height: 12px; border-radius: 50%; border: 1px solid #ddd;
        flex-shrink: 0;
      }
    `;
    document.head.appendChild(style);
  }

  // ─── Shade color map (used by the grid to render color dots) ───
  var SHADE_COLOR_MAP = {
    'Porcelain': '#E8C9A8',
    'Fair': '#EACDA8',
    'Light': '#D9B48F',
    'Medium': '#C49A6C',
    'Golden Medium': '#B8894F',
    'Sand': '#A67B4B',
    'Tan': '#8E6840',
    'Deep': '#6B4832',
    'Toffee': '#5A3825'
  };

  // ─── Dropdown version (for BLUSH) ───
  function renderShadeAlternativesDropdown(parent, data) {
    var mainData = data?.storefrontProductVariant || (data?.variant && {
      variant: data.variant,
      ext_id: data.ext_id || data.variant?.ext_id,
      imageUrl: data.imageUrl || data.variant?.photoUrl,
      storefrontProduct: data.storefrontProduct || data
    }) || null;
    var mainVariant = mainData?.variant;
    if (!mainVariant || !mainData) return;

    var productHandle = (mainData.storefrontProduct && mainData.storefrontProduct.handle) ? mainData.storefrontProduct.handle : (mainData.handle || data?.product_handle || data?.productHandle || '');
    var mainExtId = mainData.ext_id != null ? String(mainData.ext_id) : (mainVariant.ext_id != null ? String(mainVariant.ext_id) : (mainVariant.id != null ? String(mainVariant.id) : ''));
    if (!productHandle) return;

    injectDrawerShadeAlternativesStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-shade-alternatives';
    section.setAttribute('data-hue-drawer', 'shade-alternatives');
    section.setAttribute('data-recommended-variant-id', mainExtId);

    var chevronSvg = '<svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>';
    section.innerHTML =
      '<div class="hue-drawer-shade-alternatives__header">' +
        '<h2 class="hue-drawer-shade-alternatives__title">Still Not Sure Of Your Shade?</h2>' +
        '<p class="hue-drawer-shade-alternatives__subtitle">Pick a backup shade, just in case.</p>' +
      '</div>' +
      '<div class="hue-drawer-shade-alternatives__dropdown-wrap">' +
        '<div class="hue-drawer-shade-alternatives__variant-select">' +
          '<div class="hue-drawer-shade-alternatives__control" role="combobox" aria-expanded="false" aria-haspopup="listbox" tabindex="0">' +
            '<div class="hue-drawer-shade-alternatives__swatch"></div>' +
            '<div class="hue-drawer-shade-alternatives__value-wrap">' +
              '<p class="hue-drawer-shade-alternatives__value">Loading shades…</p>' +
              '<p class="hue-drawer-shade-alternatives__value-description"></p>' +
            '</div>' +
            '<div class="hue-drawer-shade-alternatives__indicator">' + chevronSvg + '</div>' +
          '</div>' +
          '<input type="hidden" data-hue-drawer-shade-select value="">' +
          '<div class="hue-drawer-shade-alternatives__menu" role="listbox"></div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="hue-drawer-shade-alternatives__atc" data-hue-drawer-try-shades-atc disabled>TRY THEM BOTH FOR $0</button>';
    parent.appendChild(section);

    var selectEl = section.querySelector('[data-hue-drawer-shade-select]');
    var atcBtn = section.querySelector('[data-hue-drawer-try-shades-atc]');
    var controlEl = section.querySelector('.hue-drawer-shade-alternatives__control');
    var menuEl = section.querySelector('.hue-drawer-shade-alternatives__menu');
    function setAtcDisabled() {
      if (atcBtn) atcBtn.disabled = !selectEl || !selectEl.value;
    }
    function setControlDisplay(option) {
      if (!controlEl) return;
      var swatch = controlEl.querySelector('.hue-drawer-shade-alternatives__swatch');
      var valueEl = controlEl.querySelector('.hue-drawer-shade-alternatives__value');
      var descEl = controlEl.querySelector('.hue-drawer-shade-alternatives__value-description');
      if (option) {
        if (swatch) {
          swatch.innerHTML = option.imageUrl ? '<img src="' + escapeAttr(option.imageUrl) + '" alt="' + escapeAttr(option.label) + '" loading="lazy">' : '';
        }
        if (valueEl) valueEl.textContent = option.label;
        if (descEl) { descEl.textContent = option.description || ''; descEl.style.display = option.description ? '' : 'none'; }
      } else {
        if (swatch) swatch.innerHTML = '';
        if (valueEl) valueEl.textContent = 'Loading shades…';
        if (descEl) { descEl.textContent = ''; descEl.style.display = 'none'; }
      }
    }
    function closeMenu() {
      if (controlEl) controlEl.classList.remove('is-open');
      if (controlEl) controlEl.setAttribute('aria-expanded', 'false');
      if (menuEl) menuEl.classList.remove('is-open');
    }
    function openMenu() {
      if (controlEl) controlEl.classList.add('is-open');
      if (controlEl) controlEl.setAttribute('aria-expanded', 'true');
      if (menuEl) menuEl.classList.add('is-open');
    }
    function toggleMenu() {
      var isOpen = menuEl && menuEl.classList.contains('is-open');
      if (isOpen) closeMenu(); else openMenu();
    }
    if (controlEl) {
      controlEl.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu();
      });
      controlEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMenu(); }
      });
    }
    document.addEventListener('click', function outsideClick(e) {
      if (!section.contains(e.target)) closeMenu();
    });

    function runTryShadesAtc(btn) {
      var sec = btn.closest('.hue-drawer-shade-alternatives');
      if (!sec) return;
      var recommendedId = sec.getAttribute('data-recommended-variant-id');
      var sel = sec.querySelector('[data-hue-drawer-shade-select]');
      var selectedId = sel ? sel.value : '';
      if (!recommendedId || !selectedId) return;
      var variantIds = [recommendedId, selectedId];
      btn.disabled = true;
      var sellingPlanId = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.sellingPlanId) || TRYNOW_SELLING_PLAN_ID;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
        : '';
      function addOne(index) {
        if (index >= variantIds.length) {
          if (document.onAddToCart) document.onAddToCart();
          if (window.trynow && typeof window.trynow.addToCartClicked === 'function') {
            window.trynow.addToCartClicked();
          }
          return Promise.resolve();
        }
        var formData = new FormData();
        formData.set('id', variantIds[index]);
        formData.set('quantity', '1');
        formData.set('selling_plan', String(sellingPlanId));
        if (sectionIds) formData.set('sections', sectionIds);
        return fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (result.ok && result.data && result.data.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(result.data);
              cartDrawer.classList.remove('is-empty');
            } else if (!result.ok) {
              console.warn('Hue drawer try shades: add failed for variant', variantIds[index], result.data);
            }
            return addOne(index + 1);
          });
      }
      addOne(0).catch(function (err) {
        console.error('Hue drawer try shades ATC failed:', err);
      }).finally(function () {
        btn.disabled = false;
      });
    }
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (atcBtn.disabled) return;
        runTryShadesAtc(atcBtn);
      });
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(productHandle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (product) {
        if (!selectEl || !section || !menuEl) return;
        var variants = product.variants || [];
        var mainName = (mainVariant.name || '').trim();
        var selectedShopifyId = null;
        var options = variants.map(function (v) {
          var id = String(v.id);
          var label = (v.option1 || v.title || id).trim();
          var desc = (v.option2 || v.option3 || '').trim();
          var img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
          var isMatch = id === mainExtId || (mainName && (v.option1 || v.title || '').trim() === mainName);
          if (isMatch) selectedShopifyId = id;
          return { id: id, label: label, description: desc, imageUrl: img, isMatch: isMatch };
        });
        var liquidDescriptions = (window.HUE_VARIANT_DESCRIPTIONS && window.HUE_VARIANT_DESCRIPTIONS[productHandle]) || null;
        console.log('liquidDescriptions', liquidDescriptions);
        if (liquidDescriptions && typeof liquidDescriptions === 'object') {
          options.forEach(function (opt) {
            var d = liquidDescriptions[opt.id];
            if (d && String(d).trim()) opt.description = String(d).trim();
          });
        }
        if (selectedShopifyId) section.setAttribute('data-recommended-variant-id', selectedShopifyId);
        var optionsExcludingRecommended = options.filter(function (opt) { return !opt.isMatch; });
        if (optionsExcludingRecommended.length === 0) {
          setControlDisplay(null);
          selectEl.value = '';
          menuEl.innerHTML = '';
          setAtcDisabled();
          return;
        }
        menuEl.innerHTML = optionsExcludingRecommended.map(function (opt, idx) {
          var swatchHtml = opt.imageUrl ? '<img src="' + escapeAttr(opt.imageUrl) + '" alt="' + escapeAttr(opt.label) + '" loading="lazy">' : '';
          var descHtml = opt.description ? '<p class="hue-drawer-shade-alternatives__value-description">' + escapeHtml(opt.description) + '</p>' : '';
          var selectedClass = idx === 0 ? ' is-selected' : '';
          return '<div class="hue-drawer-shade-alternatives__option' + selectedClass + '" role="option" data-variant-id="' + escapeAttr(opt.id) + '" data-label="' + escapeAttr(opt.label) + '" data-description="' + escapeAttr(opt.description) + '" data-image-url="' + escapeAttr(opt.imageUrl || '') + '">' +
            '<div class="hue-drawer-shade-alternatives__swatch">' + swatchHtml + '</div>' +
            '<div class="hue-drawer-shade-alternatives__value-wrap">' +
              '<p class="hue-drawer-shade-alternatives__value">' + escapeHtml(opt.label) + '</p>' + descHtml +
            '</div></div>';
        }).join('');
        var selectedOption = optionsExcludingRecommended[0];
          selectEl.value = selectedOption.id;
          setControlDisplay(selectedOption);
          menuEl.querySelectorAll('.hue-drawer-shade-alternatives__option').forEach(function (optEl) {
            optEl.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var id = optEl.getAttribute('data-variant-id');
              var label = optEl.getAttribute('data-label') || '';
              var description = optEl.getAttribute('data-description') || '';
              var imageUrl = optEl.getAttribute('data-image-url') || '';
              selectEl.value = id;
              setControlDisplay({ id: id, label: label, description: description, imageUrl: imageUrl });
              menuEl.querySelectorAll('.hue-drawer-shade-alternatives__option').forEach(function (o) { o.classList.remove('is-selected'); });
              optEl.classList.add('is-selected');
              closeMenu();
              setAtcDisabled();
            });
          });
          setAtcDisabled();
      })
      .catch(function () {
        setControlDisplay(null);
        if (selectEl) selectEl.value = '';
        if (menuEl) menuEl.innerHTML = '';
        setAtcDisabled();
      });
  }

  // ─── Grid / checkbox version (for BnB FOUNDATION) ───
  function renderShadeAlternativesGrid(parent, data) {
    var mainData = data?.storefrontProductVariant || (data?.variant && {
      variant: data.variant,
      ext_id: data.ext_id || data.variant?.ext_id,
      imageUrl: data.imageUrl || data.variant?.photoUrl,
      storefrontProduct: data.storefrontProduct || data
    }) || null;
    var mainVariant = mainData?.variant;
    if (!mainVariant || !mainData) return;

    var productHandle = (mainData.storefrontProduct && mainData.storefrontProduct.handle) ? mainData.storefrontProduct.handle : (mainData.handle || data?.product_handle || data?.productHandle || '');
    var mainExtId = mainData.ext_id != null ? String(mainData.ext_id) : (mainVariant.ext_id != null ? String(mainVariant.ext_id) : (mainVariant.id != null ? String(mainVariant.id) : ''));
    if (!productHandle) return;

    injectDrawerShadeAlternativesStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-shade-alternatives';
    section.setAttribute('data-hue-drawer', 'shade-alternatives');
    section.setAttribute('data-recommended-variant-id', mainExtId);

    var checkSvg = '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 3.5L5.5 10L2.5 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    section.innerHTML =
      '<div class="hue-drawer-shade-alternatives__header">' +
        '<h2 class="hue-drawer-shade-alternatives__title">Still Not Sure Of Your Shade Match?</h2>' +
        '<p class="hue-drawer-shade-alternatives__subtitle">Try multiple shades to ensure the perfect match.</p>' +
      '</div>' +
      '<div class="hue-drawer-shade-grid" data-hue-shade-grid></div>' +
      '<button type="button" class="hue-drawer-shade-alternatives__atc" data-hue-drawer-grid-atc disabled>TRY THEM ALL FOR $0</button>';
    parent.appendChild(section);

    var gridEl = section.querySelector('[data-hue-shade-grid]');
    var atcBtn = section.querySelector('[data-hue-drawer-grid-atc]');

    function updateAtcState() {
      var checked = section.querySelectorAll('.hue-drawer-shade-grid__card.is-checked');
      if (atcBtn) atcBtn.disabled = checked.length === 0;
    }

    // ATC handler: add all checked shades to cart with TryNow selling plan
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (atcBtn.disabled) return;
        var checkedCards = section.querySelectorAll('.hue-drawer-shade-grid__card.is-checked');
        var variantIds = [];
        checkedCards.forEach(function (card) {
          var vid = card.getAttribute('data-variant-id');
          if (vid) variantIds.push(vid);
        });
        if (variantIds.length === 0) return;
        atcBtn.disabled = true;
        var sellingPlanId = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.sellingPlanId) || TRYNOW_SELLING_PLAN_ID;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartDrawer = document.querySelector('cart-drawer');
        var sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
          ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
          : '';
        function addOne(index) {
          if (index >= variantIds.length) {
            if (document.onAddToCart) document.onAddToCart();
            if (window.trynow && typeof window.trynow.addToCartClicked === 'function') {
              window.trynow.addToCartClicked();
            }
            return Promise.resolve();
          }
          var formData = new FormData();
          formData.set('id', variantIds[index]);
          formData.set('quantity', '1');
          formData.set('selling_plan', String(sellingPlanId));
          if (sectionIds) formData.set('sections', sectionIds);
          return fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
            .then(function (result) {
              if (result.ok && result.data && result.data.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(result.data);
                cartDrawer.classList.remove('is-empty');
              } else if (!result.ok) {
                console.warn('Hue grid ATC: add failed for variant', variantIds[index], result.data);
              }
              return addOne(index + 1);
            });
        }
        addOne(0).catch(function (err) {
          console.error('Hue grid ATC failed:', err);
        }).finally(function () {
          atcBtn.disabled = false;
        });
      });
    }

    // Fetch variants from Shopify and build grid
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(productHandle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (product) {
        if (!gridEl) return;
        var variants = product.variants || [];
        var mainName = (mainVariant.name || '').trim();

        // Build ordered list of all variants (light to dark, per Shopify ordering)
        var allOptions = variants.map(function (v, idx) {
          var id = String(v.id);
          var label = (v.option1 || v.title || id).trim();
          var img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
          var isMatch = id === mainExtId || (mainName && (v.option1 || v.title || '').trim() === mainName);
          var color = SHADE_COLOR_MAP[label] || '#ccc';
          return { id: id, label: label, imageUrl: img, isMatch: isMatch, index: idx, color: color };
        });

        // Find the recommended shade index
        var recommendedIdx = -1;
        for (var i = 0; i < allOptions.length; i++) {
          if (allOptions[i].isMatch) { recommendedIdx = i; break; }
        }
        if (recommendedIdx === -1) return;

        // Update the section's recommended variant ID with the Shopify ID
        section.setAttribute('data-recommended-variant-id', allOptions[recommendedIdx].id);

        // Pick 3 shades: recommended + adjacent
        var displayShades;
        if (recommendedIdx === 0) {
          // Lightest shade: show recommended + next two darker
          displayShades = allOptions.slice(0, Math.min(3, allOptions.length));
        } else if (recommendedIdx === allOptions.length - 1) {
          // Darkest shade: show two lighter + recommended
          displayShades = allOptions.slice(Math.max(0, allOptions.length - 3));
        } else {
          // Normal case: one lighter, recommended, one darker
          displayShades = [allOptions[recommendedIdx - 1], allOptions[recommendedIdx], allOptions[recommendedIdx + 1]];
        }

        // Build the grid cards
        gridEl.innerHTML = displayShades.map(function (shade) {
          var isChecked = shade.isMatch;
          var checkedClass = isChecked ? ' is-checked' : '';
          var imgHtml = shade.imageUrl
            ? '<img class="hue-drawer-shade-grid__image" src="' + escapeAttr(shade.imageUrl) + '" alt="' + escapeAttr(shade.label) + '" loading="lazy">'
            : '<div class="hue-drawer-shade-grid__image" style="background:#eee;"></div>';
          return '<div class="hue-drawer-shade-grid__card' + checkedClass + '" data-variant-id="' + escapeAttr(shade.id) + '">' +
            '<div class="hue-drawer-shade-grid__checkbox">' + checkSvg + '</div>' +
            imgHtml +
            '<div class="hue-drawer-shade-grid__label">' +
              '<span class="hue-drawer-shade-grid__color-dot" style="background-color: ' + escapeAttr(shade.color) + ';"></span>' +
              escapeHtml(shade.label) +
            '</div>' +
          '</div>';
        }).join('');

        // Attach click handlers to toggle checkboxes
        gridEl.querySelectorAll('.hue-drawer-shade-grid__card').forEach(function (card) {
          card.addEventListener('click', function () {
            card.classList.toggle('is-checked');
            updateAtcState();
          });
        });

        updateAtcState();
      })
      .catch(function (err) {
        console.error('Hue grid: failed to fetch product variants', err);
      });
  }

  // ─── Router: picks grid (BnB foundation) or dropdown (blush) ───
  function renderShadeAlternatives(parent, data) {
    var handle = (data?.storefrontProductVariant?.storefrontProduct?.handle) ||
      (data?.storefrontProduct?.handle) ||
      (data?.product_handle) ||
      (data?.matched_products && data.matched_products[0] && data.matched_products[0].handle) || '';
    var isBlush = /blush/i.test(handle);

    if (isBlush) {
      renderShadeAlternativesDropdown(parent, data);
    } else {
      renderShadeAlternativesGrid(parent, data);
    }
  }

  // ─── Section: More To Try, On Us (hardcoded upsells) ────────────────────────
  function injectDrawerUpsellsStyles() {
    if (document.getElementById('hue-drawer-upsells-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-upsells-styles';
    style.textContent = `
      .hue-drawer-upsells {
        background: #FAF5F0;
        padding: 24px 20px 28px;
        border-top: 1px solid rgba(224, 91, 140, 0.3);
        margin-left: -20px;
        margin-right: -20px;
        width: calc(100% + 40px);
        box-sizing: border-box;
      }
      .hue-drawer-upsells__header { text-align: center; margin-bottom: 24px; }
      .hue-drawer-upsells__title {
        font-size: 24px; font-weight: 700; color: #1a1a1a; margin: 0 0 6px 0;
        font-family: 'brandon-grotesque', sans-serif;
      }
      .hue-drawer-upsells__subtitle {
        font-size: 14px; font-weight: 400; color: #1a1a1a; margin: 0;
        font-family: 'brandon-grotesque', sans-serif;
      }
      .hue-drawer-upsells__list { display: flex; flex-direction: column; gap: 20px; max-width: 100%; margin: 0 auto; }
      .hue-drawer-upsells__item {
        display: flex; align-items: flex-start; gap: 16px;
        background: #FAF5F0; padding: 16px; box-sizing: border-box;
      }
      .hue-drawer-upsells__img {
        flex-shrink: 0; width: 100px; height: 100px;
        overflow: hidden; background: #f5f5f5;
      }
      .hue-drawer-upsells__img img { width: 100%; height: 100%; object-fit: cover; }
      .hue-drawer-upsells__details { flex: 1; min-width: 0; }
      .hue-drawer-upsells__name {
        font-size: 15px; font-weight: 700; color: #1a1a1a; margin: 0 0 7px 0;
        font-family: Georgia, "Times New Roman", serif; line-height: 1.3;
      }
      .hue-drawer-upsells__price-row {
        display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 10px;
      }
      .hue-drawer-upsells__price-now {
        display: inline-block; background: #D3367F; color: #fff; font-size: 16px;
        font-weight: 700; padding: 5px 10px; border-radius: 5px;
        text-transform: uppercase; letter-spacing: 0.02em;
      }
      .hue-drawer-upsells__price-keep {
        font-size: 13px; font-weight: 400; color: #000;
      }
      .hue-drawer-upsells__price-keep-note {
        font-size: 13px;
        font-weight: 400;
      }
      .hue-drawer-upsells__atc {
        width: 56%; padding: 12px 16px; font-size: 15px; font-weight: 700;
        text-transform: uppercase;
        background: #1a1a1a; color: #fff; border: none; cursor: pointer;
        margin: 0;
      }
      .hue-drawer-upsells__atc:hover { background: #333; }
      .hue-drawer-upsells__atc:disabled { opacity: 0.7; cursor: not-allowed; }
      @media (max-width: 480px) {
        .hue-drawer-upsells__title { font-size: 20px; }
        .hue-drawer-upsells__item { padding: 12px; gap: 12px; }
        .hue-drawer-upsells__img { width: 100px; height: 100px; }
        .hue-drawer-upsells__atc { width: 80%; }
        .hue-drawer-upsells__price-now { font-size: 15px; }
        .hue-drawer-upsells__price-keep { font-size: 13px; font-weight: 400; }
      }
    `;
    document.head.appendChild(style);
  }

  function renderUpsells(parent, data) {
    var products = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.upsellProducts) || [];
    if (!products || !products.length) return;

    injectDrawerUpsellsStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-upsells';
    section.setAttribute('data-hue-drawer', 'upsells');

    var currency = '$';
    var itemsHtml = products.slice(0, 2).map(function (p) {
      var variantId = p.variantId != null ? String(p.variantId) : '';
      var title = p.title || '';
      var imageUrl = p.imageUrl || '';
      var priceDisplay = p.priceDisplay ? String(p.priceDisplay) : '';
      var priceKeepValue = priceDisplay ? escapeHtml(currency + priceDisplay + ' ') : '';
      var priceKeepNote = 'IF YOU KEEP IT';

      return '<div class="hue-drawer-upsells__item">' +
        (imageUrl ? '<div class="hue-drawer-upsells__img"><img src="' + escapeAttr(imageUrl) + '" alt="" loading="lazy" /></div>' : '') +
        '<div class="hue-drawer-upsells__details">' +
          '<h3 class="hue-drawer-upsells__name">' + escapeHtml(title) + '</h3>' +
          '<div class="hue-drawer-upsells__price-row">' +
            '<span class="hue-drawer-upsells__price-now">$0 NOW</span>' +
            '<span class="hue-drawer-upsells__price-keep">' + priceKeepValue + '<span class="hue-drawer-upsells__price-keep-note">' + escapeHtml(priceKeepNote) + '</span></span>' +
          '</div>' +
          '<button type="button" class="hue-drawer-upsells__atc" data-hue-drawer-atc data-variant-id="' + escapeAttr(variantId) + '">TRY NOW FOR $0</button>' +
        '</div></div>';
    }).join('');

    section.innerHTML =
      '<div class="hue-drawer-upsells__header">' +
        '<h2 class="hue-drawer-upsells__title">More To Try, On Us</h2>' +
        '<p class="hue-drawer-upsells__subtitle">(yes, even returns are on us)</p>' +
      '</div>' +
      '<div class="hue-drawer-upsells__list">' + itemsHtml + '</div>';
    parent.appendChild(section);
  }

  // ─── Section: With BnB / Without BnB video (after upsells, before testimonials) ─
  function injectDrawerBnbVideoStyles() {
    if (document.getElementById('hue-drawer-bnb-video-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-bnb-video-styles';
    style.textContent = `
      .hue-drawer-bnb-video {
        background: #fff;
        padding: 24px 16px 28px;
        font-family: 'Helvetica Neue', Arial, sans-serif;
      }
      .hue-drawer-bnb-video__video-wrap {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 20px;
        overflow: hidden;
        border-radius: 4px;
      }
      .hue-drawer-bnb-video__video-wrap video {
        width: 100%;
        height: auto;
        display: block;
        vertical-align: top;
      }
      .hue-drawer-bnb-video__controls {
        position: absolute;
        top: 12px;
        right: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        z-index: 1;
      }
      .hue-drawer-bnb-video__ctrl-btn {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: none;
        background: #000;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        transition: opacity 0.2s;
      }
      .hue-drawer-bnb-video__ctrl-btn:hover {
        opacity: 0.85;
      }
      .hue-drawer-bnb-video__ctrl-btn svg {
        width: 20px;
        height: 20px;
        fill: currentColor;
      }
    `;
    document.head.appendChild(style);
  }

  var BNB_VIDEO_PLAY_SVG = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  var BNB_VIDEO_PAUSE_SVG = '<svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
  var BNB_VIDEO_MUTED_SVG = '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
  var BNB_VIDEO_UNMUTED_SVG = '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';

  function renderBnbVideo(parent, data) {
    var videoUrl = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.sensitiveSkinVideoUrl) || '';
    if (!videoUrl) return;

    injectDrawerBnbVideoStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-bnb-video';
    section.setAttribute('data-hue-drawer', 'bnb-video');
    section.innerHTML =
      '<div class="hue-drawer-bnb-video__video-wrap">' +
        '<video src="' + escapeAttr(videoUrl) + '" playsinline loop></video>' +
        '<div class="hue-drawer-bnb-video__controls">' +
          '<button type="button" class="hue-drawer-bnb-video__ctrl-btn hue-drawer-bnb-video__play-pause" aria-label="Pause">' + BNB_VIDEO_PAUSE_SVG + '</button>' +
          '<button type="button" class="hue-drawer-bnb-video__ctrl-btn hue-drawer-bnb-video__mute" aria-label="Unmute">' + BNB_VIDEO_UNMUTED_SVG + '</button>' +
        '</div>' +
      '</div>';
    parent.appendChild(section);

    var wrap = section.querySelector('.hue-drawer-bnb-video__video-wrap');
    var video = wrap && wrap.querySelector('video');
    var playPauseBtn = section.querySelector('.hue-drawer-bnb-video__play-pause');
    var muteBtn = section.querySelector('.hue-drawer-bnb-video__mute');
    if (video) {
      video.muted = true;
      video.play().catch(function () {});
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            playPauseBtn.innerHTML = BNB_VIDEO_PAUSE_SVG;
            playPauseBtn.setAttribute('aria-label', 'Pause');
          } else {
            video.pause();
            playPauseBtn.innerHTML = BNB_VIDEO_PLAY_SVG;
            playPauseBtn.setAttribute('aria-label', 'Play');
          }
        });
      }
      if (muteBtn) {
        function updateMuteBtn() {
          muteBtn.innerHTML = video.muted ? BNB_VIDEO_MUTED_SVG : BNB_VIDEO_UNMUTED_SVG;
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        }
        updateMuteBtn();
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          updateMuteBtn();
        });
      }
      video.addEventListener('play', function () {
        if (playPauseBtn) {
          playPauseBtn.innerHTML = BNB_VIDEO_PAUSE_SVG;
          playPauseBtn.setAttribute('aria-label', 'Pause');
        }
      });
      video.addEventListener('pause', function () {
        if (playPauseBtn) {
          playPauseBtn.innerHTML = BNB_VIDEO_PLAY_SVG;
          playPauseBtn.setAttribute('aria-label', 'Play');
        }
      });
    }
  }

  function injectDrawerTryNowColumnsStyles() {
    if (document.getElementById('hue-drawer-trynow-columns-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-trynow-columns-styles';
    style.textContent = `
      .hue-drawer-trynow-columns {
        background: #FEE8F0;
        padding: 20px 16px;
        border-top: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        text-align: center;
        margin-left: -20px;
        margin-right: -20px;
        width: calc(100% + 40px);
        box-sizing: border-box;
      }
      .hue-drawer-trynow-columns__title {
        margin: 0 0 16px 0;
        font-size: 20px;
        font-weight: 700;
        line-height: 1.2;
        color: #1a1a1a;
        font-family: Georgia, "Times New Roman", serif;
      }
      .hue-drawer-trynow-columns__title-highlight {
        color: #E0298C;
        font-family: Georgia, "Times New Roman", serif;
      }
      .hue-drawer-trynow-columns__features {
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;
      }
      .hue-drawer-trynow-columns__feature {
        display: inline-flex;
        align-items: center;
        gap: 0.5em;
      }
      .hue-drawer-trynow-columns__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
      }
      .hue-drawer-trynow-columns__icon svg {
        display: block;
        width: 40px;
        height: 40px;
      }
      .hue-drawer-trynow-columns__feature-text {
        font-size: 15px;
        letter-spacing: 0.04em;
        color: #1a1a1a;
        line-height: 1.1;
        text-align: left;
      }
      @media (max-width: 480px) {
        .hue-drawer-trynow-columns__title { font-size: 17px; }
        .hue-drawer-trynow-columns__icon { width: 32px; height: 32px; }
        .hue-drawer-trynow-columns__icon svg { width: 32px; height: 32px; }
        .hue-drawer-trynow-columns__feature-text { font-size: 13px; }
        .hue-drawer-trynow-columns__features { gap: 8px; }
      }
    `;
    document.head.appendChild(style);
  }

  var TRYNOW_COLUMNS_SVG_CART = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#D3367F"/><path d="M24.8474 12.1921C24.9553 11.9044 24.9179 11.5834 24.7437 11.3311C24.5694 11.0789 24.2853 10.9288 23.9783 10.9288H12.1279L11.2318 8.55643C11.097 8.19369 10.7464 7.94978 10.3627 7.94978H7.73455C7.49808 7.9477 7.30518 8.14158 7.30518 8.37923C7.30518 8.61689 7.49808 8.81076 7.73455 8.81076H10.3606C10.3896 8.81076 10.4145 8.82952 10.427 8.85871L11.209 10.9267H11.2028L13.7666 17.7124H13.7749L14.5963 19.8846C13.8516 20.0806 13.2999 20.7623 13.2999 21.5691C13.2999 22.5301 14.0777 23.3098 15.0319 23.3098C15.9861 23.3098 16.7639 22.528 16.7639 21.5691C16.7639 21.2501 16.6768 20.9499 16.5274 20.6914H20.7859C20.6345 20.9499 20.5495 21.2501 20.5495 21.5691C20.5495 22.5301 21.3273 23.3098 22.2815 23.3098C23.2357 23.3098 24.0135 22.528 24.0135 21.5691C24.0135 20.6101 23.2855 19.8784 22.3728 19.8304C22.3583 19.8304 22.3417 19.8283 22.3271 19.8283H15.5401C15.511 19.8283 15.4861 19.8096 15.4758 19.7825L14.6938 17.7124H16.7618H19.7612H22.1156C22.4993 17.7124 22.8478 17.4706 22.9847 17.1099L24.8432 12.1921H24.8474ZM15.0319 22.4467C14.5506 22.4467 14.1586 22.0527 14.1586 21.5691C14.1586 21.0854 14.5506 20.6914 15.0319 20.6914C15.5131 20.6914 15.9052 21.0854 15.9052 21.5691C15.9052 22.0527 15.5131 22.4467 15.0319 22.4467ZM23.1548 21.5691C23.1548 22.0527 22.7627 22.4467 22.2815 22.4467C21.8003 22.4467 21.4082 22.0527 21.4082 21.5691C21.4082 21.0854 21.8003 20.6914 22.2815 20.6914C22.7627 20.6914 23.1548 21.0854 23.1548 21.5691ZM24.0363 11.8211C24.0509 11.8419 24.0529 11.8627 24.0446 11.8857L23.2875 13.8891H20.7175L21.0369 11.7919H23.9803C24.0052 11.7919 24.0239 11.8023 24.0363 11.8211ZM17.1311 16.8493L16.8116 14.7521H19.7135L19.3941 16.8493H17.1311ZM16.6809 13.8891L16.3615 11.7919H20.1657L19.8463 13.8891H16.6809ZM15.4924 11.7919L15.8118 13.8891H13.248L12.4556 11.7919H15.4924ZM13.5737 14.7521H15.9425L16.2619 16.8493H14.366L13.5737 14.7521ZM22.184 16.8035C22.1736 16.8306 22.1487 16.8493 22.1197 16.8493H20.2653L20.5847 14.7521H22.9598L22.184 16.8035Z" fill="white"/></svg>';
  var TRYNOW_COLUMNS_SVG_BRUSH = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#D3367F"/><path d="M15.0966 25.3755C15.0985 25.7154 15.2362 26.0535 15.4753 26.29C15.7145 26.5266 16.046 26.6686 16.394 26.6585C17.1076 26.6546 17.6897 26.0659 17.6857 25.3524L17.6262 16.1258L18.0021 11.9558L19.178 9.74235C19.5052 9.12092 19.3057 8.29823 18.7176 7.91974C18.6746 7.89446 17.7381 7.25453 16.2861 7.27131C14.8601 7.27925 13.9301 7.91273 13.8619 7.94678C13.7943 7.99766 13.7267 8.04962 13.6678 8.10914C13.2455 8.53616 13.1305 9.23244 13.4224 9.77386L14.6233 11.9573L15.037 16.1315L15.0966 25.3755ZM17.2014 25.3638C17.2039 25.8221 16.8411 26.189 16.3908 26.1834C16.1704 26.1846 15.9657 26.101 15.8123 25.9493C15.6588 25.7976 15.5725 25.5944 15.5718 25.3734L15.5129 16.3678L17.1594 16.3587L17.2014 25.3638ZM13.8458 9.55103C13.6231 9.14498 13.7558 8.6012 14.1368 8.35253C14.1454 8.3438 14.9909 7.76183 16.2899 7.76329C17.5791 7.75611 18.431 8.32862 18.4561 8.33717C18.8479 8.58968 18.9785 9.12385 18.7603 9.53235L17.6263 11.6522L15.0121 11.6668L13.8458 9.55103ZM15.1163 12.1413L17.4926 12.1281L17.1654 15.8731L15.4853 15.8825L15.1163 12.1413Z" stroke="white" stroke-width="0.64"/></svg>';
  var TRYNOW_COLUMNS_SVG_CHECK = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#D3367F"/><path d="M20.4483 13.7569C20.8987 14.5596 21.1555 15.4856 21.1555 16.4715C21.1555 19.5398 18.6682 22.0271 15.6 22.0271C12.5317 22.0271 10.0444 19.5398 10.0444 16.4715C10.0444 13.4033 12.5317 10.916 15.6 10.916C16.0118 10.916 16.4132 10.9608 16.7995 11.0458" stroke="white" stroke-width="1.28" stroke-linecap="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1934 15.4661L15.6051 19.1919L13.1934 15.4661Z" fill="white"/><path d="M13.1934 15.4661L15.6051 19.1919" stroke="white" stroke-width="1.28" stroke-linecap="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.0905 7.74435L15.6071 19.1317L21.0905 7.74435Z" fill="white"/><path d="M21.0905 7.74435L15.6071 19.1317" stroke="white" stroke-width="1.28" stroke-linecap="round"/></svg>';

  // ─── Section: TryNow columns (Claim Your Free Trial + 3 features) ────────────
  function renderTryNowColumns(parent, data) {
    injectDrawerTryNowColumnsStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-trynow-columns';
    section.setAttribute('data-hue-drawer', 'trynow-columns');
    section.innerHTML =
      '<h2 class="hue-drawer-trynow-columns__title">Claim Your <span class="hue-drawer-trynow-columns__title-highlight">Free Trial</span> Before It\'s Gone</h2>' +
      '<div class="hue-drawer-trynow-columns__features">' +
        '<div class="hue-drawer-trynow-columns__feature">' +
          '<span class="hue-drawer-trynow-columns__icon" aria-hidden="true">' + TRYNOW_COLUMNS_SVG_CART + '</span>' +
          '<span class="hue-drawer-trynow-columns__feature-text">Try for $0</span>' +
        '</div>' +
        '<div class="hue-drawer-trynow-columns__feature">' +
          '<span class="hue-drawer-trynow-columns__icon" aria-hidden="true">' + TRYNOW_COLUMNS_SVG_BRUSH + '</span>' +
          '<span class="hue-drawer-trynow-columns__feature-text">14-Day Free Trial</span>' +
        '</div>' +
        '<div class="hue-drawer-trynow-columns__feature">' +
          '<span class="hue-drawer-trynow-columns__icon" aria-hidden="true">' + TRYNOW_COLUMNS_SVG_CHECK + '</span>' +
          '<span class="hue-drawer-trynow-columns__feature-text">Love It? Keep It!<br>Or Return for Free</span>' +
        '</div>' +
      '</div>';
    parent.appendChild(section);
  }

  var TESTIMONIALS_STAR_SVG = '<svg viewBox="0 0 20 20" fill="#111" width="16" height="16"><polygon points="10,1.5 12.6,7.1 18.7,7.6 14,11.7 15.5,17.8 10,14.5 4.5,17.8 6,11.7 1.3,7.6 7.4,7.1"/></svg>';
  var TESTIMONIALS_CHECK_SVG = '<svg viewBox="0 0 20 20" fill="none" stroke="#8b1a2b" stroke-width="2.5" width="12" height="12"><polyline points="4,10.5 8.5,15 16,5"/></svg>';
  var DRAWER_TESTIMONIALS_DATA = [
    { title: 'I only paid for what I loved.', text: 'Buying makeup online is hard especially as you get older. I never know how a shade will look or how it will sit on my fine lines and wrinkles. Trying it at home first let me see how it really looked on my skin, with no pressure.', name: 'Ally M.' },
    { title: 'Finally found my perfect shade!', text: "I've wasted so much money on foundations that looked nothing like the swatch. Being able to try before I commit was a game changer. The colors matched my skin tone perfectly and the formula felt incredible.", name: 'Sarah K.' },
    { title: 'No risk, all reward.', text: "I was skeptical about trying makeup from an online brand, but the free trial convinced me. The quality was amazing and I didn't have to spend a dime until I was sure. Best decision I've made for my beauty routine.", name: 'Jessica R.' },
    { title: 'My skin has never looked better.', text: 'The products were gentle on my sensitive skin and the coverage was flawless. I loved being able to test everything at home without any sales pressure. I ended up keeping almost everything from the trial!', name: 'Monica T.' },
    { title: 'Worth every penny and more.', text: "I've been burned by online makeup purchases before, but this trial changed everything. The lipstick shade was exactly what I expected and the lasting power was incredible. Already placed my second order!", name: 'Rachel B.' },
    { title: 'A trial that actually delivers.', text: "I signed up expecting sample-sized products but received generous portions that lasted weeks. The quality rivaled high-end brands I've used. I finally found a brand that cares about the customer experience.", name: 'Diana L.' }
  ];

  function injectDrawerTryNowTestimonialsStyles() {
    if (document.getElementById('hue-drawer-testimonials-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-testimonials-styles';
    style.textContent = `
      .hue-drawer-trynow-testimonials { background-color: #FCFBFA; padding: 24px 16px 20px; font-family: 'Helvetica Neue', Arial, sans-serif; overflow: hidden; }
      .hue-drawer-trynow-testimonials__header { text-align: center; margin-bottom: 20px; padding: 0; }
      .hue-drawer-trynow-testimonials__subtitle { font-size: 14px; color: #333; margin-bottom: 6px; font-weight: 500; }
      .hue-drawer-trynow-testimonials__subtitle .hue-drawer-trynow-testimonials__highlight { color: #8b1a2b; font-weight: 600; }
      .hue-drawer-trynow-testimonials__title { font-size: 22px; font-weight: 700; color: #111; margin: 0; }
      .hue-drawer-trynow-testimonials__carousel-wrap { max-width: 100%; padding: 0; }
      .hue-drawer-trynow-testimonials__track-container { overflow: hidden; }
      .hue-drawer-trynow-testimonials__track { display: flex; gap: 16px; transition: transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94); cursor: grab; }
      .hue-drawer-trynow-testimonials__track.is-dragging { transition: none; cursor: grabbing; }
      .hue-drawer-trynow-testimonials__card { flex: 0 0 100%; min-width: 100%; background: #fff; border-radius: 4px; padding: 20px 16px 16px; display: flex; flex-direction: column; user-select: none; box-sizing: border-box; }
      .hue-drawer-trynow-testimonials__stars { display: flex; gap: 3px; margin-bottom: 10px; }
      .hue-drawer-trynow-testimonials__card-title { font-size: 15px; font-weight: 700; color: #111; margin: 0 0 8px 0; line-height: 1.3; }
      .hue-drawer-trynow-testimonials__card-text { font-size: 13px; color: #444; line-height: 1.6; flex: 1; margin: 0 0 12px 0; }
      .hue-drawer-trynow-testimonials__divider { width: 32px; height: 2px; background: #ccc; margin-bottom: 12px; }
      .hue-drawer-trynow-testimonials__footer { display: flex; justify-content: space-between; align-items: center; }
      .hue-drawer-trynow-testimonials__name { font-size: 11px; font-weight: 700; color: #111; letter-spacing: 0.04em; text-transform: uppercase; }
      .hue-drawer-trynow-testimonials__verified { display: flex; align-items: center; gap: 4px; font-size: 11px; color: #8b1a2b; font-weight: 500; }
      .hue-drawer-trynow-testimonials__controls { display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 20px; }
      .hue-drawer-trynow-testimonials__btn { width: 40px; height: 40px; border-radius: 50%; border: 1.5px solid #333; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
      .hue-drawer-trynow-testimonials__btn:hover { background: #333; }
      .hue-drawer-trynow-testimonials__btn:hover svg { stroke: #fff; }
      .hue-drawer-trynow-testimonials__btn svg { width: 16px; height: 16px; stroke: #333; stroke-width: 2; fill: none; }
      .hue-drawer-trynow-testimonials__dots { display: flex; gap: 6px; align-items: center; }
      .hue-drawer-trynow-testimonials__dot { width: 8px; height: 8px; border-radius: 50%; background: #bbb; border: none; cursor: pointer; padding: 0; transition: background 0.25s, transform 0.25s; }
      .hue-drawer-trynow-testimonials__dot.active { background: #333; transform: scale(1.25); }
      .hue-drawer-trynow-testimonials__dot:hover { background: #888; }
    `;
    document.head.appendChild(style);
  }

  function initDrawerTestimonialsCarousel(section) {
    var track = section.querySelector('.hue-drawer-trynow-testimonials__track');
    var prevBtn = section.querySelector('.hue-drawer-trynow-testimonials__prev');
    var nextBtn = section.querySelector('.hue-drawer-trynow-testimonials__next');
    var dotsContainer = section.querySelector('.hue-drawer-trynow-testimonials__dots');
    if (!track || !prevBtn || !nextBtn || !dotsContainer) return;
    var cards = track.querySelectorAll('.hue-drawer-trynow-testimonials__card');
    var currentIndex = 0;
    var cardsPerView = 1;
    var gap = 16;
    var isDragging = false, startX = 0, currentTranslate = 0, prevTranslate = 0, dragThreshold = 50;

    function getTotalPages() { return Math.max(1, cards.length - cardsPerView + 1); }
    function buildDots() {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < getTotalPages(); i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hue-drawer-trynow-testimonials__dot' + (i === currentIndex ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () { goTo(parseInt(this.dataset.index, 10)); });
        dotsContainer.appendChild(dot);
      }
    }
    function getOffset() {
      var containerWidth = track.parentElement.offsetWidth;
      var cardWidth = (containerWidth - gap * (cardsPerView - 1)) / cardsPerView;
      return currentIndex * (cardWidth + gap);
    }
    function updateTrack(animate) {
      if (animate !== false) track.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      var offset = getOffset();
      currentTranslate = prevTranslate = -offset;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }
    function updateDots() {
      dotsContainer.querySelectorAll('.hue-drawer-trynow-testimonials__dot').forEach(function (d, i) { d.classList.toggle('active', i === currentIndex); });
    }
    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, getTotalPages() - 1));
      updateTrack();
      updateDots();
    }

    prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    track.addEventListener('mousedown', function (e) { isDragging = true; startX = e.pageX; prevTranslate = currentTranslate; track.classList.add('is-dragging'); });
    track.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      currentTranslate = prevTranslate + (e.pageX - startX);
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
    });
    track.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false; track.classList.remove('is-dragging');
      var movedBy = currentTranslate - prevTranslate;
      if (movedBy < -dragThreshold) goTo(currentIndex + 1);
      else if (movedBy > dragThreshold) goTo(currentIndex - 1);
      else updateTrack();
    });
    track.addEventListener('mouseleave', function () { if (isDragging) { isDragging = false; track.classList.remove('is-dragging'); updateTrack(); } });
    track.addEventListener('touchstart', function (e) { isDragging = true; startX = e.touches[0].clientX; prevTranslate = currentTranslate; track.classList.add('is-dragging'); }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      currentTranslate = prevTranslate + (e.touches[0].clientX - startX);
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false; track.classList.remove('is-dragging');
      var movedBy = currentTranslate - prevTranslate;
      if (movedBy < -dragThreshold) goTo(currentIndex + 1);
      else if (movedBy > dragThreshold) goTo(currentIndex - 1);
      else updateTrack();
    }, { passive: true });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    buildDots();
    updateTrack(false);
  }

  // ─── Section: TryNow testimonials carousel (mobile-style) ───────────────────
  function renderTryNowTestimonials(parent, data) {
    injectDrawerTryNowTestimonialsStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-trynow-testimonials';
    section.setAttribute('data-hue-drawer', 'trynow-testimonials');
    var cardsHtml = DRAWER_TESTIMONIALS_DATA.map(function (t) {
      return '<div class="hue-drawer-trynow-testimonials__card">' +
        '<div class="hue-drawer-trynow-testimonials__stars" aria-hidden="true">' + (TESTIMONIALS_STAR_SVG.repeat(5)) + '</div>' +
        '<h3 class="hue-drawer-trynow-testimonials__card-title">' + escapeHtml(t.title) + '</h3>' +
        '<p class="hue-drawer-trynow-testimonials__card-text">' + escapeHtml(t.text) + '</p>' +
        '<div class="hue-drawer-trynow-testimonials__divider"></div>' +
        '<div class="hue-drawer-trynow-testimonials__footer">' +
          '<span class="hue-drawer-trynow-testimonials__name">' + escapeHtml(t.name) + '</span>' +
          '<span class="hue-drawer-trynow-testimonials__verified">' + TESTIMONIALS_CHECK_SVG + 'Verified Customer</span>' +
        '</div></div>';
    }).join('');

    section.innerHTML =
      '<div class="hue-drawer-trynow-testimonials__header">' +
        '<p class="hue-drawer-trynow-testimonials__subtitle">Tired of <span class="hue-drawer-trynow-testimonials__highlight">wasting money</span> on makeup that doesn\'t work?</p>' +
        '<h2 class="hue-drawer-trynow-testimonials__title">200,000+ Loved Their Free Trial</h2>' +
      '</div>' +
      '<div class="hue-drawer-trynow-testimonials__carousel-wrap">' +
        '<div class="hue-drawer-trynow-testimonials__track-container">' +
          '<div class="hue-drawer-trynow-testimonials__track">' + cardsHtml + '</div>' +
        '</div>' +
        '<div class="hue-drawer-trynow-testimonials__controls">' +
          '<button type="button" class="hue-drawer-trynow-testimonials__btn hue-drawer-trynow-testimonials__prev" aria-label="Previous testimonials"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>' +
          '<div class="hue-drawer-trynow-testimonials__dots"></div>' +
          '<button type="button" class="hue-drawer-trynow-testimonials__btn hue-drawer-trynow-testimonials__next" aria-label="Next testimonials"><svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg></button>' +
        '</div>' +
      '</div>';
    parent.appendChild(section);
    initDrawerTestimonialsCarousel(section);
  }

  // ─── Section: Related products / upsells ────────────────────────────────────
  function renderRelated(parent, data) {
    const related = data?.relatedProductsVariants;
    if (!related || !related.length) return;

    const section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-related';
    section.setAttribute('data-hue-drawer', 'related');
    let itemsHtml = related.slice(0, 6).map(function (r) {
      const variantId = r?.ext_id;
      const name = r?.variant?.name || r?.storefrontProduct?.product?.name;
      const price = r?.storefrontProduct?.price;
      const currency = r?.storefrontProduct?.storefront?.currency?.symbol || '$';
      const img = r?.imageUrl || r?.variant?.photoUrl;
      return `
        <div class="hue-drawer-related__item" data-variant-id="${escapeAttr(variantId || '')}">
          ${img ? `<div class="hue-drawer-related__img"><img src="${escapeAttr(img)}" alt="" loading="lazy" /></div>` : ''}
          <div class="hue-drawer-related__info">
            <span class="hue-drawer-related__name">${escapeHtml(name || '')}</span>
            ${price != null ? `<span class="hue-drawer-related__price">${escapeHtml(currency)}${escapeHtml(String(price))}</span>` : ''}
            <button type="button" class="hue-drawer-related__atc" data-hue-drawer-upsell-atc data-variant-id="${escapeAttr(variantId || '')}" data-product-id="${escapeAttr((r?.storefrontProduct?.product?.id ?? '') + '')}" data-variant-name="${escapeAttr(name || '')}" data-product-name="${escapeAttr(r?.storefrontProduct?.product?.name || '')}" data-price="${escapeAttr(String(price || ''))}">Add</button>
          </div>
        </div>
      `;
    }).join('');
  }

  function injectDrawerHueReviewsStyles() {
    if (document.getElementById('hue-drawer-hue-reviews-styles')) return;
    var style = document.createElement('style');
    style.id = 'hue-drawer-hue-reviews-styles';
    style.textContent = `
      .hue-drawer-hue-reviews { background: #FCFBFA; padding: 24px 16px 20px; }
      .hue-drawer-hue-reviews__header { margin-bottom: 16px; }
      .hue-drawer-hue-reviews__title-line { display: flex; align-items: center; gap: 6px; margin: 0 0 4px 0; }
      .hue-drawer-hue-reviews__title { font-size: 18px; font-weight: 700; color: #111; text-transform: uppercase; letter-spacing: 0.02em; }
      .hue-drawer-hue-reviews__info-btn { width: 18px; height: 18px; min-width: 18px; border-radius: 50%; border: 1px solid #111; color: #111; background: transparent; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; font-size: 11px; font-weight: 700; font-family: inherit; line-height: 1; padding: 0; flex-shrink: 0; }
      .hue-drawer-hue-reviews__info-btn:hover { background: #111; color: #fff; }
      .hue-drawer-hue-reviews__subtitle { font-size: 14px; font-weight: 400; color: #111; margin: 0; line-height: 1.4; }
      .hue-drawer-geller-gal-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.35); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 16px; }
      .hue-drawer-geller-gal-modal-overlay[hidden] { display: none; }
      .hue-drawer-geller-gal-modal { background: #fff; border-radius: 8px; box-shadow: 0 4px 24px rgba(0,0,0,0.15); padding: 16px 20px; max-width: 320px; position: relative; }
      .hue-drawer-geller-gal-modal::after { content: ''; position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%); border-left: 8px solid transparent; border-right: 8px solid transparent; border-top: 8px solid #fff; filter: drop-shadow(0 2px 2px rgba(0,0,0,0.08)); }
      .hue-drawer-geller-gal-modal__text { font-size: 14px; color: #111; line-height: 1.5; margin: 0; }
      .hue-drawer-geller-gal-modal__close { position: absolute; top: 8px; right: 8px; width: 28px; height: 28px; border: none; background: transparent; color: #666; cursor: pointer; font-size: 18px; line-height: 1; padding: 0; border-radius: 4px; }
      .hue-drawer-geller-gal-modal__close:hover { background: #f0f0f0; color: #111; }
      .hue-drawer-hue-reviews__list { display: flex; flex-direction: column; gap: 16px; }
      .hue-drawer-hue-reviews__card { background: #fff; border-radius: 8px; padding: 16px; border: 1px solid #eee; }
      .hue-drawer-hue-reviews__profile { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
      .hue-drawer-hue-reviews__avatar { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; }
      .hue-drawer-hue-reviews__profile-info { min-width: 0; }
      .hue-drawer-hue-reviews__name { font-size: 14px; font-weight: 700; color: #111; }
      .hue-drawer-hue-reviews__details { font-size: 12px; color: #666; }
      .hue-drawer-hue-reviews__name-line { font-size: 14px; font-weight: 700; color: #111; }
      .hue-drawer-hue-reviews__name-line .hue-drawer-hue-reviews__handle { font-weight: 400; color: #111; }
      .hue-drawer-hue-reviews__skin-tags { display: flex; gap: 4px; max-width: 100%; overflow-x: auto; padding-bottom: 4px; margin-top: 8px; scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.25) transparent; }
      .hue-drawer-hue-reviews__skin-tags::-webkit-scrollbar { height: 4px; }
      .hue-drawer-hue-reviews__skin-tags::-webkit-scrollbar-track { background: transparent; }
      .hue-drawer-hue-reviews__skin-tags::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.25); border-radius: 2px; }
      .hue-drawer-hue-reviews__skin-tags::-webkit-scrollbar-thumb:hover { background: rgba(0,0,0,0.4); }
      .hue-drawer-hue-reviews__skin-tag { display: inline-block; font-size: 12px; color: #111; background: #fff; border: 1px solid #111; border-radius: 2px; padding: 4px 8px; line-height: 1.2; white-space: nowrap; flex-shrink: 0; }
      .hue-drawer-hue-reviews__stars { color: #111; margin-bottom: 6px; font-size: 14px; }
      .hue-drawer-hue-reviews__card-title { font-size: 15px; font-weight: 700; color: #111; margin: 0 0 6px 0; }
      .hue-drawer-hue-reviews__card-text { font-size: 14px; color: #444; line-height: 1.5; margin: 0 0 12px 0; }
      .hue-drawer-hue-reviews__assets { display: grid; grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); gap: 8px; }
      .hue-drawer-hue-reviews__asset { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 4px; }
      .hue-drawer-hue-reviews__asset-video { width: 100%; aspect-ratio: 1; border-radius: 4px; overflow: hidden; background: #000; position: relative; }
      .hue-drawer-hue-reviews__asset-video video { width: 100%; height: 100%; object-fit: cover; display: block; }
      .hue-video-wrapper { position: relative; width: 100%; aspect-ratio: 1; border-radius: 4px; overflow: hidden; cursor: pointer; background: #000; }
      .hue-video-wrapper video { width: 100%; height: 100%; object-fit: cover; display: block; }
      .hue-play-icon { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 30px; height: 30px; background: rgba(0,0,0,0.6); border-radius: 50%; display: flex; align-items: center; justify-content: center; pointer-events: none; transition: opacity 0.2s ease; }
      .hue-play-icon::after { content: ''; width: 0; height: 0; border-top: 5px solid transparent; border-bottom: 5px solid transparent; border-left: 8px solid #fff; margin-left: 2px; }
      .hue-video-wrapper.hue-playing .hue-play-icon { opacity: 0; }
      #hue-reviews-container .slick-list {
        /* Custom overrides for Hue-rendered Slick carousel */
      }
      #hue-reviews-container .hue-tag-slide {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      #hue-reviews-container .hue-tag-slide-container-content__price-container {
        display: flex;
        align-items: center;
        gap: 0;
        flex-wrap: wrap;
      }
      #hue-reviews-container .hue-tag-slide-container-content__comparedPrice {
        display: none !important;
      }
      #hue-reviews-container .hue-tag-slide-trynow-badge {
        display: inline-block;
        background: #E3008C;
        color: #fff;
        font-size: 13px;
        font-weight: 800;
        padding: 3px 5px;
        border-radius: 6px;
        text-transform: uppercase;
        letter-spacing: 0.02em;
      }
      #hue-reviews-container .hue-tag-slide-trynow-keep {
        font-size: 13px;
        margin-bottom: 1px;
        font-weight: 400;
        color: #fff;
      }
      #hue-reviews-container .hue-tag-slide-container-content__price {
        font-size: 13px;
        font-weight: 400;
        margin-left: 6px;
        margin-right: 3px;
      }
      #hue-reviews-container .hue-tag-slide__button[data-trynow-btn],
      #hue-reviews-container [data-hue-style="tag-slide-button"] {
        width: 100% !important;
        height: 35px !important;
        min-height: 35px !important;
      }
      #hue-reviews-container .hue-tag-slide .hue-btn {
        background: #fff !important;
        color: #000 !important;
        border: 1px solid #000;
      }
      #hue-reviews-container .hue-tag-slide .hue-btn:hover {
        background: #000 !important;
        color: #fff !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ─── Section: Real Results (Hue reviews from HueGetReviewsData) ─────────────
  function renderHueReviews(parent, data) {
    var reviews = (typeof window.HueGetReviewsData === 'function')
      ? window.HueGetReviewsData(data)
      : (data && data.data) ? data.data : [];
    if (!reviews || !reviews.length) return;

    injectDrawerHueReviewsStyles();
    var section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-hue-reviews';
    section.setAttribute('data-hue-drawer', 'hue-reviews');

    var listHtml = reviews.slice(0, 10).map(function (review, index) {
      var creator = review.creator || {};
      var instagramHandle = (creator.instagramHandle && String(creator.instagramHandle).trim()) ? String(creator.instagramHandle).replace(/^@/, '') : '';
      var nameLine = escapeHtml(creator.name || '');
      if (instagramHandle) nameLine += ' <span class="hue-drawer-hue-reviews__handle">(@' + escapeHtml(instagramHandle) + ')</span>';
      var skinRefs = creator.skinReferences || creator.skinCharacteristics || [];
      var skinTagTexts = skinRefs.map(function (ref) {
        if (typeof ref === 'string') return ref.trim();
        if (ref && ref.text) return String(ref.text).trim();
        return '';
      }).filter(Boolean);
      var skinTagsHtml = skinTagTexts.length
        ? '<div class="hue-drawer-hue-reviews__skin-tags">' +
            skinTagTexts.map(function (text) { return '<span class="hue-drawer-hue-reviews__skin-tag">' + escapeHtml(text) + '</span>'; }).join('') +
          '</div>'
        : '';
      var rating = review.rating != null ? Math.min(5, Math.max(0, review.rating)) : 5;
      var stars = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      var assets = review.assets || [];
      var assetsHtml = assets.map(function (asset, assetIndex) {
        var url = asset.url || '';
        var isVideo = asset.type && asset.type.type === 'VIDEO';
        if (isVideo) {
          var mutedAttr = assetIndex === 0 ? '' : ' muted';
          return '<div class="hue-video-wrapper hue-drawer-hue-reviews__asset-video" role="button" tabindex="0" onclick="document.hueToggleVideo(this, ' + index + ', ' + assetIndex + ')" data-review-index="' + index + '" data-asset-index="' + assetIndex + '">' +
            '<video src="' + escapeAttr(url) + '" playsinline loop' + mutedAttr + '></video>' +
            '<div class="hue-play-icon"></div></div>';
        }
        return '<img src="' + escapeAttr(url) + '" class="hue-drawer-hue-reviews__asset" alt="" loading="lazy">';
      }).join('');

      return '<div class="hue-drawer-hue-reviews__card" data-review-index="' + index + '">' +
        '<div class="hue-drawer-hue-reviews__profile">' +
          (creator.profileImageUrl ? '<img src="' + escapeAttr(creator.profileImageUrl) + '" class="hue-drawer-hue-reviews__avatar" alt="">' : '') +
          '<div class="hue-drawer-hue-reviews__profile-info">' +
            '<div class="hue-drawer-hue-reviews__name-line">' + nameLine + '</div>' +
            skinTagsHtml +
          '</div></div>' +
        '<div class="hue-drawer-hue-reviews__stars" aria-hidden="true">' + stars + '</div>' +
        (review.title ? '<h4 class="hue-drawer-hue-reviews__card-title">' + escapeHtml(review.title) + '</h4>' : '') +
        (review.text ? '<p class="hue-drawer-hue-reviews__card-text">' + escapeHtml(review.text) + '</p>' : '') +
        (assetsHtml ? '<div class="hue-drawer-hue-reviews__assets">' + assetsHtml + '</div>' : '') +
      '</div>';
    }).join('');

    var headerHtml =
      '<div class="hue-drawer-hue-reviews__header">' +
        '<div class="hue-drawer-hue-reviews__title-line">' +
          '<h2 class="hue-drawer-hue-reviews__title">Meet Your Geller Gal Twins</h2>' +
          '<button type="button" class="hue-drawer-hue-reviews__info-btn" aria-label="Disclaimer about Geller Gal Twins">i</button>' +
        '</div>' +
        '<p class="hue-drawer-hue-reviews__subtitle">See reviews from people wearing this shade.</p>' +
      '</div>';
    section.innerHTML =
      headerHtml +
      '<div id="hue-reviews-container" class="hue-drawer-hue-reviews__list">' + listHtml + '</div>';
    parent.appendChild(section);

    var infoBtn = section.querySelector('.hue-drawer-hue-reviews__info-btn');
    if (infoBtn) {
      var modalOverlay = document.getElementById('hue-drawer-geller-gal-modal-overlay');
      if (!modalOverlay) {
        modalOverlay = document.createElement('div');
        modalOverlay.id = 'hue-drawer-geller-gal-modal-overlay';
        modalOverlay.className = 'hue-drawer-geller-gal-modal-overlay';
        modalOverlay.setAttribute('hidden', '');
        modalOverlay.innerHTML =
          '<div class="hue-drawer-geller-gal-modal">' +
            '<button type="button" class="hue-drawer-geller-gal-modal__close" aria-label="Close">×</button>' +
            '<p class="hue-drawer-geller-gal-modal__text">Geller Gal Twins are gifted these products, but are not incentivized to post a positive review or to sell you these products.</p>' +
          '</div>';
        document.body.appendChild(modalOverlay);
        var modalBox = modalOverlay.querySelector('.hue-drawer-geller-gal-modal');
        var closeBtn = modalOverlay.querySelector('.hue-drawer-geller-gal-modal__close');
        function closeModal() { modalOverlay.setAttribute('hidden', ''); }
        modalOverlay.addEventListener('click', function (e) { if (e.target === modalOverlay) closeModal(); });
        if (closeBtn) closeBtn.addEventListener('click', closeModal);
      }
      infoBtn.addEventListener('click', function () {
        modalOverlay.removeAttribute('hidden');
      });
    }

    document.hueToggleVideo = function (wrapperElement, reviewIndex, assetIndex) {
      var video = wrapperElement.querySelector('video');
      if (!video) return;
      var isNowPlaying = false;
      if (video.paused) {
        video.play();
        wrapperElement.classList.add('hue-playing');
        isNowPlaying = true;
      } else {
        video.pause();
        wrapperElement.classList.remove('hue-playing');
        isNowPlaying = false;
      }
      var review = reviews[reviewIndex];
      if (!review) return;
      var asset = (review.assets || [])[assetIndex];
      if (!asset) return;
      var detail = {
        creatorId: review.creator && review.creator.id,
        asset: asset,
        reviewIndex: reviewIndex,
        review: review,
        playing: isNowPlaying,
        currentTime: video.currentTime,
        duration: video.duration || 0
      };
      document.dispatchEvent(new CustomEvent('hue-quiz-result-video-toggle-analytics', { detail: detail }));
    };
  }

  // ─── Section: Reviews (simple list fallback when Hue Real Results not used) ──
  function renderReviews(parent, data) {
    if (typeof window.HueGetReviewsData === 'function' && window.HueGetReviewsData(data).length > 0) return;
    const reviews = data?.data;
    if (!reviews || !reviews.length) return;

    const section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-reviews';
    section.setAttribute('data-hue-drawer', 'reviews');
    const totalCount = data?.totalCount ?? reviews.length;
    let listHtml = reviews.slice(0, 5).map(function (review, index) {
      const title = review?.title || '';
      const text = review?.text || '';
      const rating = review?.rating;
      const creatorName = review?.creator?.name;
      return `
        <div class="hue-drawer-review" data-review-index="${index}">
          ${rating != null ? `<div class="hue-drawer-review__rating" aria-hidden="true">${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}</div>` : ''}
          ${title ? `<h4 class="hue-drawer-review__title">${escapeHtml(title)}</h4>` : ''}
          ${text ? `<p class="hue-drawer-review__text">${escapeHtml(text)}</p>` : ''}
          ${creatorName ? `<span class="hue-drawer-review__author">${escapeHtml(creatorName)}</span>` : ''}
        </div>
      `;
    }).join('');
    section.innerHTML = `
      <h3 class="hue-drawer-reviews__title">Reviews</h3>
      <div class="hue-drawer-reviews__list">${listHtml}</div>
    `;
    parent.appendChild(section);
  }

  // ─── Section: Footer (close, restart) ──────────────────────────────────────
  function renderFooter(parent) {
    const section = document.createElement('div');
    section.className = 'hue-drawer-section hue-drawer-footer';
    section.setAttribute('data-hue-drawer', 'footer');
    section.innerHTML = `
      <button type="button" class="hue-drawer-footer__close" data-hue-drawer-close>Close</button>
      <button type="button" class="hue-drawer-footer__restart" data-hue-drawer-restart>Retake quiz</button>
    `;
    parent.appendChild(section);
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────
  function escapeHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }
  function escapeAttr(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * Bridge: Hue expects these on document for custom layout actions.
   * See docs/hue-quiz-result-drawer.md (Communication Bridge).
   */
  function attachHueBridge(container, data) {
    document.onCloseQuiz = function () {
      document.dispatchEvent(new CustomEvent('hue-quiz-close'));
    };
    document.onResetQuiz = function () {
      document.dispatchEvent(new CustomEvent('hue-quiz-restart'));
    };
    document.onAddToCart = function () {
      document.dispatchEvent(new CustomEvent('hue-quiz-result-add-to-cart-analytics'));
    };
    document.dispatchVariantChange = function (variantId) {
      document.dispatchEvent(new CustomEvent('hue-quiz-result-variant-changed', { detail: { variantId: variantId } }));
    };
    document.onAddUpsellToCart = function (buttonElement) {
      var el = typeof buttonElement === 'object' ? buttonElement : document.querySelector(buttonElement);
      if (!el) return;
      var payload = {
        variantId: el.dataset.variantId,
        productId: el.dataset.productId,
        variantName: el.dataset.variantName,
        productName: el.dataset.productName,
        price: Number(el.dataset.price) || 0
      };
      document.dispatchEvent(new CustomEvent('hue-quiz-result-upsell-add-to-cart-analytics', { detail: payload }));
    };
  }

  function attachDrawerListeners(container, data) {
    container.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-hue-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        if (document.onCloseQuiz) document.onCloseQuiz();
        return;
      }
      var restartBtn = e.target.closest('[data-hue-drawer-restart]');
      if (restartBtn) {
        e.preventDefault();
        if (document.onResetQuiz) document.onResetQuiz();
        return;
      }
      var tryShadesBtn = e.target.closest('[data-hue-drawer-try-shades-atc]');
      if (tryShadesBtn) {
        e.preventDefault();
        var section = tryShadesBtn.closest('.hue-drawer-shade-alternatives');
        if (!section) return;
        var recommendedId = section.getAttribute('data-recommended-variant-id');
        var selectEl = section.querySelector('[data-hue-drawer-shade-select]');
        var selectedId = selectEl ? selectEl.value : '';
        if (!recommendedId || !selectedId) return;
        var variantIds = [recommendedId, selectedId];
        tryShadesBtn.disabled = true;
        var sellingPlanId = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.sellingPlanId) || TRYNOW_SELLING_PLAN_ID;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartDrawer = document.querySelector('cart-drawer');
        var sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
          ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
          : '';
        function addOne(index) {
          if (index >= variantIds.length) {
            if (document.onAddToCart) document.onAddToCart();
            if (window.trynow && typeof window.trynow.addToCartClicked === 'function') {
              window.trynow.addToCartClicked();
            }
            return Promise.resolve();
          }
          var formData = new FormData();
          formData.set('id', variantIds[index]);
          formData.set('quantity', '1');
          formData.set('selling_plan', String(sellingPlanId));
          if (sectionIds) formData.set('sections', sectionIds);
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (result) {
              if (result.ok && result.data && result.data.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(result.data);
                cartDrawer.classList.remove('is-empty');
              } else if (!result.ok) {
                console.warn('Hue drawer try shades: add failed for variant', variantIds[index], result.data);
              }
              return addOne(index + 1);
            });
        }
        addOne(0).catch(function (err) {
          console.error('Hue drawer try shades ATC failed:', err);
        }).finally(function () {
          tryShadesBtn.disabled = false;
        });
        return;
      }
      var atcBtn = e.target.closest('[data-hue-drawer-atc]');
      if (atcBtn) {
        console.log('atc clicked', atcBtn)
        e.preventDefault();
        var variantId = atcBtn.dataset.variantId;
        if (!variantId) return;
        var sellingPlanId = (window.HUE_DRAWER_CONFIG && window.HUE_DRAWER_CONFIG.sellingPlanId) || TRYNOW_SELLING_PLAN_ID;
        var cartDrawer = document.querySelector('cart-drawer');
        var formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');
        formData.set('selling_plan', String(sellingPlanId));
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          var sectionIds = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          formData.set('sections', sectionIds.join(','));
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        atcBtn.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (res) { return res.json(); }).then(function (data) {
          if (document.onAddToCart) document.onAddToCart();
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
            cartDrawer.classList.remove('is-empty');
          } else {
            var forceRefresh = typeof forceRefreshCartDrawer === 'function' ? forceRefreshCartDrawer : null;
            if (forceRefresh) forceRefresh(); else document.dispatchEvent(new CustomEvent('cart:updated'));
          }
          if (window.trynow && typeof window.trynow.addToCartClicked === 'function') {
            window.trynow.addToCartClicked();
          }
        }).catch(function (err) {
          console.error('Hue drawer TryNow ATC failed:', err);
        }).finally(function () {
          atcBtn.disabled = false;
        });
        return;
      }
      var upsellBtn = e.target.closest('[data-hue-drawer-upsell-atc]');
      if (upsellBtn && document.onAddUpsellToCart) {
        e.preventDefault();
        document.onAddUpsellToCart(upsellBtn);
        return;
      }
      var hiwBtn = e.target.closest('[data-hue-drawer-hiw]');
      if (hiwBtn) {
        e.preventDefault();
        var modal = document.querySelector('#modalOverlayCustom');
        if (modal && typeof modal.classList !== 'undefined') {
          modal.classList.remove('custom-trynow-modal-hidden');
        } else {
          document.dispatchEvent(new CustomEvent('hue-drawer-open-hiw'));
        }
      }
    });
  }

  function updateMatchPriceFromShopify(container, data) {
    var v = data?.storefrontProductVariant;
    console.log('updateMatchPriceFromShopify', v);
    var handle = v?.storefrontProduct?.handle;
    var extId = v?.ext_id;
    var currency = v?.storefrontProduct?.storefront?.currency?.symbol || '$';
    if (!handle || extId == null) return;
    var matchSection = container.querySelector('.hue-drawer-match');
    var priceEl = matchSection ? matchSection.querySelector('.hue-drawer-match__price-struck') : null;
    if (!priceEl) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (product) {
        var variants = product.variants || [];
        var variant = variants.filter(function (v) { return String(v.id) === String(extId); })[0];
        if (variant && variant.price != null) {
          var p = variant.price;
          var displayPrice = typeof p === 'number' ? (p / 100).toFixed(2) : String(p);
          priceEl.textContent = currency + displayPrice;
        }
      })
      .catch(function () {});
  }

  // ─── Main entry: compose all sections ───────────────────────────────────────
  var SECTIONS = [
    { name: 'header', render: renderHeader },
    { name: 'match', render: renderMatch },
    { name: 'shade-alternatives', render: renderShadeAlternatives },
    { name: 'trynow-columns', render: renderTryNowColumns },
    { name: 'upsells', render: renderUpsells },
    { name: 'bnb-video', render: renderBnbVideo },
    { name: 'trynow-testimonials', render: renderTryNowTestimonials },
    { name: 'hue-reviews', render: renderHueReviews },
    { name: 'related', render: renderRelated },
    { name: 'reviews', render: renderReviews },
    { name: 'footer', render: renderFooter }
  ];

  function renderQuizLayout(container, data) {
    if (!container || !data) return;
    injectDrawerModalZIndexStyles();
    container.innerHTML = '';
    container.setAttribute('data-hue-drawer', 'root');

    var wrapper = document.createElement('div');
    wrapper.className = 'hue-drawer';

    for (var i = 0; i < SECTIONS.length; i++) {
      SECTIONS[i].render(wrapper, data);
    }

    container.appendChild(wrapper);
    updateMatchPriceFromShopify(container, data);
    attachHueBridge(container, data);
    attachDrawerListeners(container, data);
  }

  window.HueQuizResultDrawer = {
    renderQuizLayout: renderQuizLayout,
    renderHeader: renderHeader,
    renderMatch: renderMatch,
    renderShadeAlternatives: renderShadeAlternatives,
    renderUpsells: renderUpsells,
    renderBnbVideo: renderBnbVideo,
    renderTryNowColumns: renderTryNowColumns,
    renderTryNowTestimonials: renderTryNowTestimonials,
    renderHueReviews: renderHueReviews,
    injectDrawerHueReviewsStyles: injectDrawerHueReviewsStyles,
    renderRelated: renderRelated,
    renderReviews: renderReviews,
    renderFooter: renderFooter
  };
})();
